// src/App.js

import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeContextProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import tr from 'date-fns/locale/tr';
import ErrorBoundary from './components/common/ErrorBoundary';

import Login from './pages/Login';
import MainLayout from './components/common/MainLayout';
import ProtectedRoute from './components/common/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Musteriler from './pages/Musteriler';
import MusteriDetay from './pages/MusteriDetay';
import Cihazlar from './pages/Cihazlar';
import CihazDetay from './pages/CihazDetay';
import SgkCihazListesi from './pages/SgkCihazListesi'; // YENİ
import ServisPanosu from './pages/ServisPanosu';
import Raporlar from './pages/Raporlar';
import ServisKaydiOlustur from './pages/ServisKaydiOlustur';
import ServisKayitlari from './pages/ServisKayitlari';
import ServisKaydiDetay from './pages/ServisKaydiDetay';
import Hizmetler from './pages/Hizmetler';
import CariHesaplar from './pages/CariHesaplar';
import CariHesapEkstresi from './pages/CariHesapEkstresi';
import Randevular from './pages/Randevular';
import PreInterviews from './pages/PreInterviews';
import SmsYonetimi from './pages/SmsYonetimi';
import YapayZekaAyarlari from './pages/YapayZekaAyarlari';
import MarkaModelYonetimi from './pages/MarkaModelYonetimi'; // YENİ
import FirmaBilgileri from './pages/FirmaBilgileri'; // YENİ
import KullaniciYonetimi from './pages/KullaniciYonetimi';
import StokTakip from './pages/StokTakip';
import UykuTakip from './pages/UykuTakip';
import PeriyodikBakim from './pages/PeriyodikBakim';
import SatisOlustur from './pages/SatisOlustur';
import UrunSatisKayitlari from './pages/UrunSatisKayitlari';
import UykuTakipDetay from './pages/UykuTakipDetay';
import RandevuDetay from './pages/RandevuDetay';

function App() {
  return (
    <ErrorBoundary>
      <ThemeContextProvider>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={tr}>
          <AuthProvider>
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/*" element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
                  <Route index element={<Navigate to="/dashboard" replace />} />
                  <Route path="dashboard" element={<Dashboard />} />
                  <Route path="musteriler" element={<Musteriler />} />
                  <Route path="musteri/:id" element={<MusteriDetay />} />
                  <Route path="cihazlar" element={<Cihazlar />} />
                  <Route path="cihaz/:id" element={<CihazDetay />} />
                  <Route path="sgk-cihazlari" element={<SgkCihazListesi />} /> {/* YENİ */}
                  <Route path="servis-panosu" element={<ServisPanosu />} />
                  <Route path="on-gorusme" element={<PreInterviews />} />
                  <Route path="randevular" element={<Randevular />} />
                  <Route path="raporlar" element={<ProtectedRoute allowedRoles={['Yönetici']}><Raporlar /></ProtectedRoute>} />
                  <Route path="servis-kaydi-olustur" element={<ServisKaydiOlustur />} />
                  <Route path="servis-kayitlari" element={<ServisKayitlari />} />
                  <Route path="servis-kaydi/:id" element={<ServisKaydiDetay />} />
                  <Route path="servis-kaydi/duzenle/:id" element={<ServisKaydiOlustur />} />
                  <Route path="hizmetler" element={<Hizmetler />} />
                  <Route path="cari-hesaplar" element={<ProtectedRoute allowedRoles={['Yönetici', 'Ofis Personeli']}><CariHesaplar /></ProtectedRoute>} />
                  <Route path="cari-hesaplar/:id" element={<ProtectedRoute allowedRoles={['Yönetici', 'Ofis Personeli']}><CariHesapEkstresi /></ProtectedRoute>} />
                  <Route path="sms-yonetimi" element={<ProtectedRoute allowedRoles={['Yönetici']}><SmsYonetimi /></ProtectedRoute>} />
                  <Route path="ayarlar/yapay-zeka" element={<ProtectedRoute allowedRoles={['Yönetici']}><YapayZekaAyarlari /></ProtectedRoute>} />
                  <Route path="ayarlar/marka-model" element={<ProtectedRoute allowedRoles={['Yönetici', 'Ofis Personeli']}><MarkaModelYonetimi /></ProtectedRoute>} /> {/* YENİ */}
                  <Route path="ayarlar/firma-bilgileri" element={<ProtectedRoute allowedRoles={['Yönetici']}><FirmaBilgileri /></ProtectedRoute>} /> {/* YENİ */}
                  <Route path="kullanici-yonetimi" element={<ProtectedRoute allowedRoles={['Yönetici']}><KullaniciYonetimi /></ProtectedRoute>} />
                  <Route path="stok-takip" element={<ProtectedRoute allowedRoles={['Yönetici', 'Ofis Personeli']}><StokTakip /></ProtectedRoute>} />
                  <Route path="uyku-takip" element={<ProtectedRoute allowedRoles={['Yönetici', 'Ofis Personeli']}><UykuTakip /></ProtectedRoute>} />
                  <Route path="periyodik-bakim" element={<ProtectedRoute allowedRoles={['Yönetici', 'Ofis Personeli']}><PeriyodikBakim /></ProtectedRoute>} />
                  <Route path="satis-olustur" element={<SatisOlustur />} />
                  <Route path="satis-detay/:id" element={<SatisOlustur />} />
                  <Route path="urun-satis-kayitlari" element={<UrunSatisKayitlari />} />

                  {/* Yeni Rotalar (v7) */}
                  <Route path="uyku-takip/yeni" element={<ProtectedRoute allowedRoles={['Yönetici', 'Ofis Personeli']}><UykuTakipDetay /></ProtectedRoute>} />
                  <Route path="uyku-takip/:id" element={<ProtectedRoute allowedRoles={['Yönetici', 'Ofis Personeli']}><UykuTakipDetay /></ProtectedRoute>} />
                  <Route path="randevu/yeni" element={<RandevuDetay />} />
                  <Route path="randevu/:id" element={<RandevuDetay />} />
                </Route>
              </Routes>
            </Router>
          </AuthProvider>
        </LocalizationProvider>
      </ThemeContextProvider>
    </ErrorBoundary>
  );
}

export default App;